import { useUser } from './UserContext';

export const ROLE_LEVELS = { admin: 10, super_user: 20, user: 30 };
export const ROLE_LABELS = { admin: 'Admin', super_user: 'Super User', user: 'User' };
export const FULL_ACCESS_LEVEL = 20;

function parseUser(u) { try { return JSON.parse(u) || {}; } catch { return {}; } }

export function useRole() {
  const { user } = useUser();
  const userData = parseUser(user);
  const role = userData.role || null;
  const level = ROLE_LEVELS[role] ?? 99;
  const isAdmin = level <= FULL_ACCESS_LEVEL;

  // Project access: null = full access (admin/super), array = explicit grants
  const projects = userData.projects;
  const hasProjectAccess = isAdmin || (Array.isArray(projects) && projects.length > 0);

  // IoT access: null = full access (admin/super), array = explicit grants
  const iotAccess = userData.iotAccess;
  const hasIotAccess = isAdmin || (Array.isArray(iotAccess) && iotAccess.length > 0);

  return {
    role,
    level,
    userId: userData.userId,
    isAdmin,
    isFullAccess: isAdmin,
    hasProjectAccess,
    hasIotAccess,
    iotAccess: iotAccess || [],
  };
}
